<template>
  <div>
    <base-info-card
      id="share-email-form"
      :title="title"
      :subtitle="subtitle"
      space="4"
      color="primary"
    />

    <base-text-field
      v-model="shareEmail"
      label="Email"
    />

    <v-slide-y-transition>
      <v-card
        v-show="showSentShareLinkEmailText"
        class="mb-6"
        flat
        transparent
      >
        <v-card-text>
          <div
            class="white--text"
          >
            <v-icon color="white">
              mdi-check
            </v-icon>
            {{ shareCardText }}
          </div>
        </v-card-text>
      </v-card>
    </v-slide-y-transition>

    <base-btn
      :color="!theme.isDark ? 'accent' : 'white'"
      outlined
      @click="shareLinkWithEmail()"
    >
      {{ $t('SHARE_LINK_BY_EMAIL_SECTION_BUTTON_TEXT') }}
    </base-btn>
  </div>
</template>

<script>
  // import submitApiServices from '@/helpers/submit_endpoints'

  export default {
    name: 'BaseContactForm',

    // Injected from the Vuetify Themeable mixin
    inject: ['theme'],

    props: {
      subtitle: {
        type: String,
        required: false,
      },
      title: {
        type: String,
        required: false,
      },
    },

    data () {
      return {
        shareEmail: '',
        shareCardText: '',
        isShareCardDark: true,
        showSentShareLinkEmailText: false,
        isEmailAlreadySentInSession: false,
        latestShareEmail: '',
      }
    },

    methods: {
      async shareLinkWithEmail () {
        const shareEmail = this.shareEmail
        if (!shareEmail) { return }

        const sameEmail = (shareEmail === this.latestShareEmail)
        const isAlreadySent = this.isEmailAlreadySentInSession

        if (sameEmail && isAlreadySent) {
          this._showAndHideAlreadySentShareLinkEmail()
        } else {
          this.$emit('shareLinkWithEmail', shareEmail)
          this._showAndHideSuccessfullySentShareLinkEmail()
          this.latestShareEmail = shareEmail
          this.isEmailAlreadySentInSession = true
        }
      },

      _showAndHideSuccessfullySentShareLinkEmail (timeout1 = 500, timeout2 = 3000) {
        /** Pure UX utility.
        */
        const that = this
        setTimeout(function () {
          that.shareCardText = that.$t('SHARE_LINK_BY_EMAIL_SUBMIT_SUCCESS_TEXT')
          that.showSentShareLinkEmailText = true
        }, timeout1)
        setTimeout(function () {
          that.showSentShareLinkEmailText = false
        }, timeout2)
      },

      _showAndHideAlreadySentShareLinkEmail (timeout1 = 500, timeout2 = 3000) {
        /** Pure UX utility.
        */
        const that = this
        setTimeout(function () {
          that.shareCardText = that.$t('SHARE_LINK_BY_EMAIL_ALREADY_SUBMITTED_TEXT')
          that.showSentShareLinkEmailText = true
        }, timeout1)
        setTimeout(function () {
          that.showSentShareLinkEmailText = false
        }, timeout2)
      },
    },
  }
</script>
